import { useKidsPolicy } from "@/components/features/_hooks/use-kids-policy/use-kids-policy";

import { useProductRoomFormModelContext } from "../../../../../context";

export const useRoomKidsPolicy = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { kidsPolicy } = viewModel;

	return useKidsPolicy({ kidsPolicy, onSetViewModel });
};
